import { __decorate } from "tslib";
import { Component } from '@angular/core';
import { DomSanitizer } from "@angular/platform-browser";
import { WebsiteThemeService } from "../../services/website-theme.service";
import { LocationStrategy } from "@angular/common";
let ExchangeAddressConfirmationMailSentComponent = class ExchangeAddressConfirmationMailSentComponent {
    constructor(sanitizer, themeService, location) {
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.location = location;
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.textColor = '';
        this.inputBackColor = '';
        this.inputTextColor = '';
        this.successColor = '';
        this.buttonClicked = false;
        this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
        this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
        this.inputTextColor = this.themeService.getStyleAttribute('input_text_color');
        this.inputBackColor = this.themeService.getStyleAttribute('input_background_color');
        this.textColor = this.themeService.getStyleAttribute('text_color');
        this.successColor = this.themeService.getStyleAttribute('success_color');
        location.onPopState(() => {
            this.close();
        });
    }
    ngOnInit() {
    }
    close() {
        this.modal.destroy();
    }
};
ExchangeAddressConfirmationMailSentComponent.ctorParameters = () => [
    { type: DomSanitizer },
    { type: WebsiteThemeService },
    { type: LocationStrategy }
];
ExchangeAddressConfirmationMailSentComponent = __decorate([
    Component({
        selector: 'app-exchange-address-confirmation-mail-sent',
        template: __importDefault(require("./exchange-address-confirmation-mail-sent.component.html")).default
    })
], ExchangeAddressConfirmationMailSentComponent);
export { ExchangeAddressConfirmationMailSentComponent };
